import {Component, OnInit} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'indicadores-comparativo-widget',
  templateUrl: '../../templates/widgets/indicadores.comparativo.widget.template.html'
})
export class IndicadoresComparativoWidgetComponent implements OnInit {

  public datosTabla: any[] = [];

  public datosPar: any[] = [];

  constructor(private rs: ReporteServices) {

  }

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string, fecha3: string, fecha4: string) {
    this.datosTabla = [];

    this.datosPar = [];
    let consultas: any[] = [];
    consultas.push(this.rs.devolverReporteIndicadores(entidad, idEntidad, fecha1, fecha2));
    consultas.push(this.rs.devolverReporteIndicadores(entidad, idEntidad, fecha3, fecha4));

    forkJoin(consultas).subscribe((d:any) => {
      // console.log(d[0]);
      let data1 = JSON.parse(d[0].data.reporteIndicadores);
      for (let d1 of data1) {
        d1.periodo = `${fecha1} - ${fecha2}`;
        let par = {
          id: d1.id,
          cv: d1.cv,
          nombres: d1.nombres,
          cargo: d1.cargo,
          per1: d1
        };
        this.datosPar.push(par);
      }

      let data2 = JSON.parse(d[1].data.reporteIndicadores);

      for (let d2 of data2) {
        let p = this.datosPar.find(dp => dp.id == d2.id);

        if (p) {
          p.per2 = d2;
          p.per2.periodo = `${fecha3} - ${fecha4}`
        } else {
          let par = {
            id: d2.id,
            cv: d2.cv,
            nombres: d2.nombres,
            cargo: d2.cargo,
            per1: undefined,
            per2: d2
          };

          this.datosPar.push(par);
        }
      }

      for (let p of this.datosPar) {
        if (p.per1 && p.per2) {
          p.per3 = {
            periodo:"",
            ticket: (p.per2.ticket / p.per1.ticket * 100) - 100,
            ticketPromedio: (p.per2.ticketPromedio / p.per1.ticketPromedio * 100) - 100,
            artxticket: (p.per2.artxticket / p.per1.artxticket * 100) - 100,
            ticketdia: (p.per2.ticketdia / p.per1.ticketdia * 100) - 100,
            ventaxdia: (p.per2.ventaxdia / p.per1.ventaxdia * 100) - 100,
            cumplimiento:  (p.per2.cumplimiento / p.per1.cumplimiento * 100) - 100
          };
        }
      }



    });

    this.rs.devolverReporteIndicadores(entidad, idEntidad, fecha1, fecha2).subscribe(d => {

      if (d.data.reporteIndicadores) {
        let data = JSON.parse(d.data.reporteIndicadores);
        // console.log(data);

        for (let d of data) {
          this.datosTabla.push(d);
        }
      }
    });
  }

  ngOnInit(): void {

  }

  semaforoPorcentaje(porcInd:any){
    let clases = [];
    if(porcInd < 0)
      clases.push('semRojo');
    else
      clases.push("semVerde");

    return clases;
  }

  semaforoIndGeneral(indicador: any, valor) {
    let clases = [];

    if (!this.rs.mostrarSemaforo)
      return clases;

    switch (indicador) {
      case 1:
        if (valor < this.rs.indicadores.ticketPromedio)
          clases.push('semRojo');
        break;
      case 2:
        if (valor < this.rs.indicadores.articuloTicket)
          clases.push('semRojo');
        break;
      case 3:
        if (valor < this.rs.indicadores.ticketDia)
          clases.push('semRojo');
        break;
      case 4:
        if (valor < this.rs.indicadores.ventaDia)
          clases.push('semRojo');
        break;
    }

    return clases;
  }

  comprobarIncrementoIndicador(val1: number, val2: number) {
    let classes = [];

    if (val1 > val2)
      classes.push('mdi mdi-arrow-down');
    else
      classes.push('mdi mdi-arrow-up');

    return classes;
  }

}
